import React from 'react';
import classes from './InputButton.module.css'

const InputButton = (props) => {
    return (
        <input
            className={classes.myButton}
            type='submit'
            value={props.text}
        />
    );
};
export default InputButton
